<template>
    <div class="px-3 py-2">
        <b-sidebar aria-labelledby="sidebar-no-header-title" width="700px" no-header id="salary_paid" backdrop :style="`direction:${$parent.lang.dir}`" right title="اضافة مصروف دوري" shadow >
            <template #default="{ hide }">
                <div class="m-1 text-start" :style="`direction:rtl`">
                    <div style="width:150px;margin-right:10px;background:#000;color:#FFF;border-radius:5px" class="btn-primary btn-sm text-center">
                        <span style="font-size:.8em;">{{$parent.lang.salary_paid}}</span>
                    </div>
                    <div @click="hide" id="xxhideExp" style="width:100px;text-align:center;float:left;margin-left:5px;margin-top:-25px;cursor:pointer" class="btn-danger btn-sm">
                        <span>{{$parent.lang.close}}</span>
                    </div>
                </div>
                <v-divider></v-divider>
                <div class="px-3 py-2" :style="`direction:`+$parent.lang.dir">
                    <v-form ref="apform">
                        <div class="m-2 p-3 backRed">{{ $parent.lang.old_balance }}: {{ restSalary }}</div>
                        <v-row>
                            <v-col cols="12" md="4" sm="12">
                                <label>{{$parent.lang.payment_amount}}</label>
                                <b-form-input class="inborder"
                                    v-model="amount"
                                    :rules="fieldRules"
                                    ></b-form-input>
                            </v-col>
                            <v-col cols="12" md="4" sm="12">
                                <label>{{$parent.lang.date}}</label>
                                <div class="flexTay">
                                    <b-form-select class="inborder text-center" style="width:30%;background:#efefef;" v-model="sd.day" :options="$store.state.daysList"/>
                                    <b-form-select class="inborder text-center" style="width:30%;background:#efefef;" v-model="sd.month" :options="$store.state.monthsList" />
                                    <b-form-select class="inborder text-center" style="width:60%;background:#efefef;" v-model="sd.year" :options="$store.state.yearList" />
                                </div>
                            </v-col>
                            <v-col cols="12" md="4" sm="12">
                                <label>{{$parent.lang.payment_type}}</label>
                                <b-input-group>
                                <b-form-select
                                    class="selborder"
                                    v-model="payment_type"
                                    :options="paytypes"
                                    :label="$parent.lang.payment_type"
                                    ></b-form-select>
                                <b-input-group-append style="margin-right:-20px;margin-top:5px;">
                                    <i class="fas fa-arrow-down"></i>
                                    </b-input-group-append>
                                </b-input-group>
                            </v-col>
                        </v-row>
                    </v-form>
                </div>
            </template>
            <template #footer="" class="shadow">
                <div class="d-flex text-light align-items-center px-3 py-2">
                    <b-button type="button" variant="success" @click="addit()" class="ma-2" style="width:100px;">{{$parent.lang.add}}</b-button>
                </div>
            </template>
        </b-sidebar>
    </div>
</template>

<script>
import axios from 'axios'
import {SnotifyPosition} from 'vue-snotify';
export default{
    data() {
        return {
            empid: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            amount: '',
            restSalary: '',
            payment_type: 1,
            month: '',
            year: '',
            fieldRules: [
                v => v > 0 || this.$parent.lang.mor_than_zero
            ],
            paytypes: [],
            retAcc: [],
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            sd: {
                day: (new Date()).getDate(),
                month: (new Date()).getMonth() + 1,
                year: (new Date()).getFullYear(),
            }
        }
    },
    computed: {
        installment_amount: function() {
            let t = 0;
            t = this.$RoundNum(parseFloat(this.amount) / parseFloat(this.installment_number));
            return t.toString() == "NaN" ? 0 : t;
        },
        payment_date: function(){
            return  `${this.sd.year}-${('0'+this.sd.month).slice(-2)}-${('0'+this.sd.day).slice(-2)}`;
        }
    },
    created(){
        this.getPyamentType();
    },
    methods: {
        getEmployees()
        {
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type" , "getAllEmp");
            post.append("auth",this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[id]',this.empid);
            post.append('data[month]',this.month);
            post.append('data[year]',this.year);
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                const res = response.data.results.data;
                this.empid = res[0].id;
                this.restSalary = res[0].restSalary;
                
            })
        },
        getPyamentType(){
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('type','getPayTypes');
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[id]',"all");
            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                const res = response.data;
                this.payTypeOp = [];
                for(let i=0;i<res.results.data.length;i++){
                    this.paytypes.push({
                        text: this.$parent.lang.langname == 'ar' ? res.results.data[i].type_name : res.results.data[i].type_name_en,
                        value: res.results.data[i].id
                    })
                    this.retAcc = res.results.retAcc;
                }
            })
        },
        addit() {
            let vald = true;
            let message = '';
            if(this.amount == '' || this.amount <= 0){
                vald = false;
                message = this.$parent.lang.mor_than_zero;
            }
            if(this.date == ''){
                vald = false;
                message = this.$parent.lang.date_required;
            }
            if(this.retAcc[this.payment_type] < this.amount && this.$store.state.licenseType.allowPayInCredit){
                vald = false;
                message = 'طريقة الدفع لا تملك رصيد كافي .. يرجى اخيتار طريقة دفع اخرى'
            }
            if(!vald){
                this.$snotify.error(message, this.$parent.lang.alert, {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.$parent.lang.close, 
                            action: (toast) => {
                                this.$snotify.remove(toast.id); 
                            } 
                        },
                    ]
                });
                return false;
            }
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("type","addVouchter");
            post.append("auth",this.$cookies.get(this.$COOKIEPhase))
            post.append("data[amount]",this.amount);
            post.append("data[empid]",this.empid);

            post.append('data[mobile]',"")
            post.append('data[full_name]',"")
            post.append('data[payspan]',0)
            post.append('data[paycash]',0)

            post.append('data[docid]',this.empid);
            post.append('data[doc_type]',"salaries");
            post.append('data[type]',2);
            post.append('data[amount]',this.amount)
            post.append('data[paytype]',this.payment_type)
            post.append('data[notes]',"سداد مستحقات رواتب")
            post.append('data[date]',this.date)
            post.append('data[payment_date]',this.payment_date)

            axios.post(
                this.$store.state.SAMCOTEC.r_path, post
            ).then((response) => {
                this.amount = '',
                document.getElementById('xxhideExp').click();
                this.$parent.getEmployees();

            })
        }
    },
}
</script>

<style scoped>
.flexTay{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    justify-items: center;
}
.flexTay select{
    margin-inline-end: 2px;
}
</style>
